import React from 'react';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router';
import Hero from 'components/Hero';
import SimpleFeed from 'components/SimpleFeed';
import Responsive from 'react-responsive';
import './Resources.scss';

export default class Resources extends React.Component {
    constructor (props) {
        super(props);
    }

    componentDidMount () {
    }

    render() {
        const Default = props => <Responsive {...props} minWidth={1025}/>;
        const TabletLg = props => <Responsive {...props} minWidth={921} maxWidth={1024} />;
        const TabletMd = props => <Responsive {...props} minWidth={841} maxWidth={920} />;
        const TabletSm = props => <Responsive {...props} minWidth={770} maxWidth={840} />;
        const MobileLg = props => <Responsive {...props} minWidth={641} maxWidth={769} />;
        const MobileXmd = props => <Responsive {...props} minWidth={541} maxWidth={640} />;
        const MobileMd = props => <Responsive {...props} minWidth={416} maxWidth={540} />;
        const MobileSmLg = props => <Responsive {...props} minWidth={376} maxWidth={415} />;
        const MobileSm = props => <Responsive {...props} minWidth={321} maxWidth={375} />;
        const MobileXsm = props => <Responsive {...props} maxWidth={320} />;

        const resourceFeeds = [
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1020+Card+1.png" ,
                title: "NOON DIRECTOR",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/1_NOON_Director.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/Mask+Group+1.png" ,
                title: "NOON EXTENSION",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/2_NOON_Extension.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/400_on%3Aoff.png" ,
                title: "NOON ON/OFF SWITCH",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/3_NOON_ON_OFF.jpg")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+card+4.png" ,
                title: "NOON LIGHTING SYSTEM",
                subtitle: "3-GANG",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/4_NOON_Three_Gang.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+Card+5.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/5_switchpair.jpg")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+Card+6.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/6_NOON_Switches.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/400_integrations.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/7_NOON_partners.jpg")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+Card+8.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/8_NOON_Switches.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/Card+9.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/9_NOON_Switches.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/400_brochure.png" ,
                title: "NOON BROCHURE - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/NOON_brochure_v7_digital.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+Card+11.png" ,
                title: "NOON Z-FOLD - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/Z-fold_3.3.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+card+12.png" ,
                title: "NOON BRAND GUIDE - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/noon-brand-guide.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+Card+13.png" ,
                title: "NOON SELL SHEETS - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/Sell_sheets_REV_summer2019.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+card+14.png" ,
                title: "NOON INSTRUCTIONS - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/MDU_Handoff_intstructions.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+card+15.png" ,
                title: "NOON INSTALLATION GUIDE",
                subtitle: "ENGLISH AND SPANISH - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/NOON_Installation_instructions.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+Card+16.png" ,
                title: "ON/OFF SWITCH",
                subtitle: "INSTALLATION GUIDE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/NOON_On%3AOff_Instructions.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+Card+17.png" ,
                title: "NOON LOGO",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/noon-logo-pms2336c.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/400_revlogo.png" ,
                title: "NOON LOGO - REVERSE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/logo_white.png")}`,
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+Card+19.png" ,
                title: "AUTHORIZE NOON DEALER BADGE",
                ctaLabel: "",
                ctaRoute: "",
                disclaimer: "Available after requirements met"
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/1920+Card+20.png" ,
                title: "AUTHORIZE NOON INSTALLER",
                subtitle: "BADGE",
                ctaLabel: "",
                ctaRoute: "",
                disclaimer: "Available after requirements met"
            },
        ];

        const resourceFeeds375 = [
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Card+1.png" ,
                title: "NOON DIRECTOR",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/1_NOON_Director.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Group+1.png" ,
                title: "NOON EXTENSION",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/2_NOON_Extension.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375_on%3Aoff.png" ,
                title: "NOON ON/OFF SWITCH",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/3_NOON_ON_OFF.jpg")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+card+4.png" ,
                title: "NOON LIGHTING SYSTEM",
                subtitle: "3-GANG",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/4_NOON_Three_Gang.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Card+5.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/5_switchpair.jpg")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Card+6.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/6_NOON_Switches.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375_integrations.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/7_NOON_partners.jpg")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Card+8.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/8_NOON_Switches.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Card+9.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/9_NOON_Switches.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375_brochure.png" ,
                title: "NOON BROCHURE - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/NOON_brochure_v7_digital.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Card+11.png" ,
                title: "NOON Z-FOLD - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/Z-fold_3.3.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+card+12.png" ,
                title: "NOON BRAND GUIDE - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/noon-brand-guide.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Card+13.png" ,
                title: "NOON SELL SHEETS - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/Sell_sheets_REV_summer2019.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+card+14.png" ,
                title: "NOON INSTRUCTIONS - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/MDU_Handoff_intstructions.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+card+15.png" ,
                title: "NOON INSTALLATION GUIDE",
                subtitle: "ENGLISH AND SPANISH - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/NOON_Installation_instructions.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Card+16.png" ,
                title: "ON/OFF SWITCH",
                subtitle: "INSTALLATION GUIDE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/NOON_On%3AOff_Instructions.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Card+17.png" ,
                title: "NOON LOGO",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/noon-logo-pms2336c.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375_revlogo.png" ,
                title: "NOON LOGO - REVERSE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/logo_white.png")}`,
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Card+19.png" ,
                title: "AUTHORIZE NOON DEALER",
                subtitle: "BADGE",
                ctaLabel: "",
                ctaRoute: "",
                disclaimer: "Available after requirements met"
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/375/375+Card+20.png" ,
                title: "AUTHORIZE NOON INSTALLER",
                subtitle: "BADGE",
                ctaLabel: "",
                ctaRoute: "",
                disclaimer: "Available after requirements met"
            },

        ];

        const resourceFeeds320 = [
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Card+1.png" ,
                title: "NOON DIRECTOR",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/1_NOON_Director.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Group+1.png" ,
                title: "NOON EXTENSION",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/2_NOON_Extension.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320_on%3Aoff.png" ,
                title: "NOON ON/OFF SWITCH",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/3_NOON_ON_OFF.jpg")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+card+4.png" ,
                title: "NOON LIGHTING SYSTEM",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/4_NOON_Three_Gang.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Card+5.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/5_switchpair.jpg")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Card+6.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/6_NOON_Switches.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320_integrations.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/7_NOON_partners.jpg")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Card+8.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/8_NOON_Switches.png")}`,
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Card+9.png" ,
                title: "MARKETING IMAGE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/9_NOON_Switches.png")}`,
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320_brochure.png" ,
                title: "NOON BROCHURE - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/NOON_brochure_v7_digital.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Card+11.png" ,
                title: "NOON Z-FOLD - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/Z-fold_3.3.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+card+12.png" ,
                title: "NOON BRAND GUIDE - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/noon-brand-guide.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Card+13.png" ,
                title: "NOON SELL SHEETS - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/Sell_sheets_REV_summer2019.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+card+14.png" ,
                title: "NOON INSTRUCTIONS - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/MDU_Handoff_intstructions.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+card+15.png" ,
                title: "NOON INSTALLATION GUIDE",
                subtitle: "ENGLISH AND SPANISH - DIGITAL",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/NOON_Installation_instructions.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Card+16.png" ,
                title: "ON/OFF SWITCH",
                ctaLabel: "DOWNLOAD",
                ctaRoute: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feed+docs/NOON_On%3AOff_Instructions.pdf",
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Card+17.png" ,
                title: "NOON LOGO",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/noon-logo-pms2336c.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320_revlogo.png" ,
                title: "NOON LOGO - REVERSE",
                ctaLabel: "DOWNLOAD",
                ctaRoute: `${require("assets/img/feeds/logo_white.png")}`
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Card+19.png" ,
                title: "AUTHORIZE NOON DEALER",
                ctaLabel: "",
                ctaRoute: "",
                disclaimer: "Available after requirements met"
            },
            {
                img: "https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Feeds/320/320+Card+20.png" ,
                title: "AUTHORIZE NOON",
                ctaLabel: "",
                ctaRoute: "",
                disclaimer: "Available after requirements met"
            },
        ];


        return(
            <section className='resources-hold-div'>
                <div>
                    <Default>
                        <Hero
                            poster='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Hero/Marquee+1920.png'
                            title = 'Brand assets'
                            subtitle = '& resources'
                            description='NOON LIGHTING SYSTEM'
                        />
                    </Default>
                    <TabletLg>
                        <Hero
                            poster='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Hero/Marquee+1024.png'
                            title = 'Brand assets'
                            subtitle = '& resources'
                            description='NOON LIGHTING SYSTEM'
                        />
                    </TabletLg>
                    <TabletMd>
                        <Hero
                            poster='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Hero/Marquee+920.png'
                            title = 'Brand assets'
                            subtitle = '& resources'
                            description='NOON LIGHTING SYSTEM'
                        />
                    </TabletMd>
                    <TabletSm>
                        <Hero
                            poster='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Hero/Marquee+840.png'
                            title = 'Brand assets'
                            subtitle = '& resources'
                            description='NOON LIGHTING SYSTEM'
                        />
                    </TabletSm>
                    <MobileLg>
                        <Hero
                            poster='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Hero/Marquee+769.png'
                            title = 'Brand assets'
                            subtitle = '& resources'
                            description='NOON LIGHTING SYSTEM'
                        />
                    </MobileLg>
                    <MobileXmd>
                        <Hero
                            poster='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Hero/Marquee+640.png'
                            title = 'Brand assets'
                            subtitle = '& resources'
                            description='NOON LIGHTING SYSTEM'
                        />
                    </MobileXmd>
                    <MobileMd>
                        <Hero
                            poster='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Hero/Marquee+540.png'
                            title = 'Brand assets'
                            subtitle = '& resources'
                            description='NOON LIGHTING SYSTEM'
                        />
                    </MobileMd>
                    <MobileSmLg>
                        <Hero
                            poster='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Hero/Marquee++415.png'
                            title = 'Brand assets'
                            subtitle = '& resources'
                            description='NOON LIGHTING SYSTEM'
                        />
                    </MobileSmLg>
                    <MobileSm>
                        <Hero
                            poster='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Hero/Marquee+375.png'
                            title = 'Brand assets'
                            subtitle = '& resources'
                            description='NOON LIGHTING SYSTEM'
                        />
                    </MobileSm>
                    <MobileXsm>
                        <Hero
                            poster='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/Resources/Hero/Marquee+320.png'
                            title = 'Brand assets'
                            subtitle = '& resources'
                            description='NOON LIGHTING SYSTEM'
                        />
                    </MobileXsm>
                </div>
                <div>
                    <Default>
                        <section className='feed-holder-sec'>
                            <div className='row-container-holder'>
                                <SimpleFeed simpleFeeds={resourceFeeds}/>
                            </div>
                        </section>
                    </Default>
                    <TabletLg>
                        <section className='feed-holder-sec'>
                            <div className='row-container-holder'>
                                <SimpleFeed simpleFeeds={resourceFeeds}/>
                            </div>
                        </section>
                    </TabletLg>
                    <TabletMd>
                        <section className='feed-holder-sec'>
                            <div className='row-container-holder'>
                                <SimpleFeed simpleFeeds={resourceFeeds}/>
                            </div>
                        </section>
                    </TabletMd>
                    <TabletSm>
                        <section className='feed-holder-sec'>
                            <div className='row-container-holder'>
                                <SimpleFeed simpleFeeds={resourceFeeds}/>
                            </div>
                        </section>
                    </TabletSm>
                    <MobileLg>
                        <section className='feed-holder-sec'>
                            <div className='row-container-holder'>
                                <SimpleFeed simpleFeeds={resourceFeeds}/>
                            </div>
                        </section>
                    </MobileLg>
                    <MobileXmd>
                        <section className='feed-holder-sec'>
                            <div className='row-container-holder'>
                                <SimpleFeed simpleFeeds={resourceFeeds}/>
                            </div>
                        </section>
                    </MobileXmd>
                    <MobileMd>
                        <section className='feed-holder-sec'>
                            <div className='row-container-holder'>
                                <SimpleFeed simpleFeeds={resourceFeeds}/>
                            </div>
                        </section>
                    </MobileMd>
                    <MobileSmLg>
                        <section className='feed-holder-sec'>
                            <div className='row-container-holder'>
                                <SimpleFeed simpleFeeds={resourceFeeds375}/>
                            </div>
                        </section>
                    </MobileSmLg>
                    <MobileSm>
                        <section className='feed-holder-sec'>
                            <div className='row-container-holder'>
                                <SimpleFeed simpleFeeds={resourceFeeds375}/>
                            </div>
                        </section>
                    </MobileSm>
                    <MobileXsm>
                        <section className='feed-holder-sec'>
                            <div className='row-container-holder'>
                                <SimpleFeed simpleFeeds={resourceFeeds320}/>
                            </div>
                        </section>
                    </MobileXsm>
                </div>


            </section>
        )

    }
}



// WEBPACK FOOTER //
// ./src/routes/Resources/index.js